import { resolveTitle } from '../../../shared/sourceTitleResolver';

export const resolveSourceStoryDisplayLabel = (entry = {}, loggedDateLabel = '') => {
  return resolveTitle(entry, 'timeline-scene', { loggedDateLabel });
};

export default resolveSourceStoryDisplayLabel;
